var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Footer'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-btn-kefu"},[_c('a',{attrs:{"href":"https://www.v5kf.com/public/chat/chat?sid=164032&entry=5&ref=link&human=0","target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/icon/icon_service1.png")}})])])
}]

export { render, staticRenderFns }